import React from 'react';
import satBadge from '../../assets/images/badges/badge-sat-pac-58354.png';
import iso27001Badge from '../../assets/images/badges/badge-iso-27001.png';
import './PacCredentialsSection.css';

const PacCredentialsSection = () => {
  return (
    <section className="df-pac-section" id="pac">
      <div className="df-pac-container">
        {/* Sellos de Certificación */}
        <div className="df-pac-badges">
          <a
            href="http://omawww.sat.gob.mx/tramitesyservicios/Paginas/pac_digitalfactura.htm"
            target="_blank"
            rel="noopener noreferrer"
            title="Verificar registro oficial en el portal del SAT"
            className="df-pac-sat-link"
          >
            <img
              src={satBadge}
              alt="SAT Proveedor Autorizado 58354"
              className="df-pac-badge-sat"
            />
          </a>

          <img
            src={iso27001Badge}
            alt="Organización certificada ISO/IEC 27001 Seguridad de la Información"
            className="df-pac-badge-iso"
          />
        </div>

        {/* Separador vertical oficial de la muestra */}
        <div className="df-pac-divider" aria-hidden="true"></div>

        {/* Contenido Oficial */}
        <div className="df-pac-content">
          <h2 className="df-pac-title">
            Somos Proveedor Autorizado de Certificación (PAC).
          </h2>
          <p className="df-pac-desc">
            Desde el año 2011 contamos con la autorización del SAT para la certificación de sus comprobantes, cumpliendo los requisitos de la <b>ISO 27001.</b>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PacCredentialsSection;
